import { PatientRatio } from './patient-ratio.model';

export class InpatientConfiguration {
    id: number;
    costCenterId: number;
    targetWHPUOS: number;
    minCensus: number;
    maxCensus: number;
    totalPatientCensus: boolean;
    transfers: boolean;
    patientRatios: PatientRatio[];
    modifiedByUserName: string;
    modifiedDate: Date;
    CreatedDate?: Date;
    InactivatedDate?: Date;
}
